import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

interface StatusBannerProps {
  status: 'operational' | 'degraded' | 'down';
  message: string;
}

const StatusBanner = ({ status, message }: StatusBannerProps) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'operational':
        return {
          bg: 'bg-emerald-500',
          text: 'text-white',
          icon: <CheckCircle className='h-6 w-6' />,
        };
      case 'degraded':
        return {
          bg: 'bg-amber-500',
          text: 'text-white',
          icon: <AlertTriangle className='h-6 w-6' />,
        };
      case 'down':
        return {
          bg: 'bg-red-500',
          text: 'text-white',
          icon: <XCircle className='h-6 w-6' />,
        };
      default:
        return {
          bg: 'bg-gray-500',
          text: 'text-white',
          icon: <CheckCircle className='h-6 w-6' />,
        };
    }
  };

  const styles = getStatusStyles();

  return (
    <div className={`${styles.bg} ${styles.text} rounded-lg p-4 shadow-sm`}>
      <div className='flex items-center gap-3'>
        {styles.icon}
        <span className='text-lg font-semibold'>{message}</span>
      </div>
    </div>
  );
};

export default StatusBanner;
